module.exports = __webpack_public_path__ + "img/nav_class.102459ce.png";